import {Content} from "./content.model";

export class Contents {
  items?: Content[];
  totalElements?: number;
  totalPages?: number
}
